export default __webpack_public_path__ + "static/media/desktopMockup2.16403e93.jpg";